import { Card, Badge } from "react-bootstrap";
import { Calendar, GeoAlt } from "react-bootstrap-icons";
import "./styles.css";

const EventCard = ({ data }) => {
 
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();
    return `${day} ${month}, ${year}`; // "11 Oct, 2025"
  };

  return (
    <Card className="event-card shadow-sm border-0">
      {/* Image Section */}
      <div className="position-relative">
        <Card.Img
          variant="top"
          src={data?.profile_image}
          className="event-image"
        />

        {/* Top Left Badge */}
        <Badge bg="" text="" className="badge-left">
          {data?.type}
        </Badge>

        {/* Top Right Badge */}
        <Badge bg="" text="" className="badge-right event-status">
          {data?.event_status}
        </Badge>
      </div>

      {/* Card Body */}
      <Card.Body>
        <div className="d-flex justify-content-between align-items-start">
          <Card.Title className="fw-semibold mb-3">{data?.name}</Card.Title>

          <Badge bg="" text="" className="px-3 py-2 border isPaid">
            {data?.is_paid ? "Paid" : "Free"}
          </Badge>
        </div>

        {/* Date */}
        <div className="text-muted d-flex align-items-center gap-2 mb-2">
          <Calendar size={16} />
          <span>
            {formatDate(data?.start_date)} -{" "}
            {formatDate(data?.end_date)}
          </span>
        </div>

        {/* Location */}
        <div className="text-muted d-flex align-items-center gap-2 mb-3">
          <GeoAlt size={16} />
          <span>{data?.address}</span>
        </div>

        {/* Tags */}
        <div className="d-flex gap-2 flex-wrap">
          {data?.sports?.map((sport) => (
            <Badge key={sport.sport_id} pill bg="" className="sport-list">
              {sport.sport_name}
            </Badge>
          ))}
        </div>
      </Card.Body>
    </Card>
  );
};

export default EventCard;
